export const validationCreatePractice = (practice) => {
  const { Nome_pratica } = practice?.Incarico || {};

  const errors = [];

  if (!Nome_pratica) errors.push("Nome_pratica");

  return errors;
};

export const validationPracticeStepOne = (practice, documentAssignment) => {
  const {
    Nome_pratica,
    responsabile_pratica,
    SOB,
    Prodotto_richiesto,
    Team_riferimento,
    valore_associato_pratica,
    altri_contatti_email_notification,
    readers_email,
  } = practice?.Incarico || {};

  const errors = [];

  if (!documentAssignment) errors.push("documentAssignment");
  if (!Nome_pratica) errors.push("Nome_pratica");
  if (!responsabile_pratica) errors.push("responsabile_pratica");
  if (!SOB) errors.push("SOB");
  if (!Prodotto_richiesto || Object.keys(Prodotto_richiesto).length === 0)
    errors.push("Prodotto_richiesto");
  if (!Team_riferimento || Object.keys(Team_riferimento).length === 0)
    errors.push("Team_riferimento");
  if (!valore_associato_pratica || valore_associato_pratica === "")
    errors.push("valore_associato_pratica");
  if (!altri_contatti_email_notification)
    errors.push("altri_contatti_email_notification");

  if (altri_contatti_email_notification > 0) {
    for (let i = 0; i < altri_contatti_email_notification; i++) {
      if (
        !readers_email ||
        !readers_email[i] ||
        readers_email[i].trim() === ""
      ) {
        errors.push(`readers_email_${i}`);
      } else {
        // controllo formato email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(readers_email[i])) {
          errors.push(`readers_email_${i}_invalid`);
        }
      }
    }
  }

  return errors;
};

export const validationPracticeStepTwo = (practice) => {
  const {
    tipologia,
    lingua_corrispondenza,
    nome,
    cognome,
    codice_fiscale,
    comune,
    indirizzo,
    CAP,
    email_principale,
    email_fatture,
    altri_contatti,
    contatti,
    cliente_partnership,
    partita_iva,
    denominazione_sociale,
    accordo_cliente_partner,
    SDI,
    segmento_operatività,
    status,
    contatto_principale_CRM,
    denominazione_gruppo_holding,
    capogruppo,
    relazione_cliente_gruppo,
    appartiene_gruppo_societario,
    cliente_collegamento_societa,
    cliente_ruolo,
    cliente_affiliato_gruppo_societari,
    cliente_provenienza,
    cliente_area_provenienza,
  } = practice?.cliente || {};

  const errors = [];

  if (!tipologia) {
    errors.push("tipologia");
  }

  if (!status) errors.push("status");

  // Condizione per 'status'
  if (status === "Nuovo cliente") {
    // Validazione completa
    if (!tipologia) {
      errors.push("tipologia");
    }

    if (!status) errors.push("status");

    if (!segmento_operatività) errors.push("segmento_operatività");
    if (!lingua_corrispondenza) errors.push("lingua_corrispondenza");

    if (!email_principale) errors.push("email_principale");
    if (!contatto_principale_CRM) errors.push("contatto_principale_CRM");
    if (!email_fatture) errors.push("email_fatture");
    if (!altri_contatti) errors.push("altri_contatti");
    if (!cliente_partnership) errors.push("cliente_partnership");

    if (tipologia === "Persona fisica italiana") {
      if (altri_contatti === "Sì" && !contatti) errors.push("contatti");
      if (cliente_partnership === "Sì" && !accordo_cliente_partner)
        errors.push("accordo_cliente_partner");
      if (!nome) errors.push("nome");
      if (!cognome) errors.push("cognome");
      // if (!codice_fiscale) errors.push("codice_fiscale");
      if (!comune) errors.push("comune");
      if (!indirizzo) errors.push("indirizzo");
    } else if (tipologia === "Persona fisica altro paese UE") {
      if (altri_contatti === "Sì" && !contatti) errors.push("contatti");
      if (cliente_partnership === "Sì" && !accordo_cliente_partner)
        errors.push("accordo_cliente_partner");
      if (!nome) errors.push("nome");
      if (!cognome) errors.push("cognome");
      // if (!codice_fiscale) errors.push("codice_fiscale");
      if (!comune) errors.push("comune");
      if (!indirizzo) errors.push("indirizzo");
    } else if (tipologia === "Persona fisica extra UE") {
      if (altri_contatti === "Sì" && !contatti) errors.push("contatti");
      if (cliente_partnership === "Sì" && !accordo_cliente_partner)
        errors.push("accordo_cliente_partner");
      if (!nome) errors.push("nome");
      if (!cognome) errors.push("cognome");
      if (!comune) errors.push("comune");
      if (!indirizzo) errors.push("indirizzo");
    } else if (tipologia === "Persona giuridica italiana") {
      if (!denominazione_sociale) errors.push("denominazione_sociale");
      // if (!partita_iva) errors.push("partita_iva");
      if (!comune) errors.push("comune");
      if (!indirizzo) errors.push("indirizzo");

      if (altri_contatti === "Sì" && !contatti) errors.push("contatti");
      if (cliente_partnership === "Sì" && !accordo_cliente_partner)
        errors.push("accordo_cliente_partner");
    } else if (tipologia === "Persona giuridica altro paese UE") {
      if (!denominazione_sociale) errors.push("denominazione_sociale");
      // if (!partita_iva) errors.push("partita_iva");
      if (!comune) errors.push("comune");
      if (!indirizzo) errors.push("indirizzo");
      if (altri_contatti === "Sì" && !contatti) errors.push("contatti");
      if (cliente_partnership === "Sì" && !accordo_cliente_partner)
        errors.push("accordo_cliente_partner");
    } else if (tipologia === "Persona giuridica extra UE") {
      if (!denominazione_sociale) errors.push("denominazione_sociale");
      // if (!partita_iva) errors.push("partita_iva");
      if (!comune) errors.push("comune");
      if (!indirizzo) errors.push("indirizzo");
      if (altri_contatti === "Sì" && !contatti) errors.push("contatti");
      if (cliente_partnership === "Sì" && !accordo_cliente_partner)
        errors.push("accordo_cliente_partner");
    }

    if (appartiene_gruppo_societario === "Sì") {
      if (
        tipologia === "Persona giuridica italiana" ||
        tipologia === "Persona giuridica altro paese UE" ||
        tipologia === "Persona giuridica extra UE"
      ) {
        if (!denominazione_gruppo_holding)
          errors.push("denominazione_gruppo_holding");
        if (!capogruppo) errors.push("capogruppo");
        if (!relazione_cliente_gruppo) errors.push("relazione_cliente_gruppo");
      }
    }

    if (cliente_affiliato_gruppo_societari === "Sì") {
      if (
        tipologia === "Persona fisica italiana" ||
        tipologia === "Persona fisica altro paese UE" ||
        tipologia === "Persona fisica extra UE"
      ) {
        if (!denominazione_gruppo_holding)
          if (!cliente_collegamento_societa)
            errors.push("cliente_collegamento_societa");
        if (!cliente_ruolo) errors.push("cliente_ruolo");
      }
    }
  } else if (status === "Già cliente LEXIA") {
    if (!status) errors.push("status");

    if (!tipologia) errors.push("tipologia");
    if (!cliente_provenienza) errors.push("cliente_provenienza");

    if (cliente_provenienza === "Sì") {
      if (!cliente_area_provenienza) errors.push("cliente_area_provenienza");
    }

    if (
      tipologia === "Persona fisica italiana" ||
      tipologia === "Persona fisica altro paese UE" ||
      tipologia === "Persona fisica extra UE"
    ) {
      if (!nome) errors.push("nome");
      if (!cognome) errors.push("cognome");
    } else if (
      tipologia === "Persona giuridica italiana" ||
      tipologia === "Persona giuridica altro paese UE" ||
      tipologia === "Persona giuridica extra UE"
    ) {
      if (!denominazione_sociale) errors.push("denominazione_sociale");
    }
  }

  return errors;
};

export const validationPracticeStepTree = (practice) => {
  const {
    pro_forma_fattura,
    modalità_compenso,
    team_compenso_condiviso,
    percentuale_spese,
    compenso_condiviso,
    condizioni_pagamento,
    compensi_outsourcing,
    compenso_complessivo,
    riferimento_calcolo,
    tariffa_oraria,
    dettagli_fatturazione_compenso,
    compenso_combinazione_forfait_listino,
    dettagli_divisione,
    dettagli_compensi_outsourcing,
    periodo_competenza_inizio,
    periodo_competenza_fine,
    percentuale_spese_specifica,
    tariffa_specifica,
  } = practice?.compenso || {};

  const errors = [];

  if (!pro_forma_fattura) {
    errors.push("pro_forma_fattura");
  }

  if (!modalità_compenso) errors.push("modalità_compenso");
  if (!percentuale_spese) errors.push("percentuale_spese");
  if (!compenso_condiviso) errors.push("compenso_condiviso");
  if (!condizioni_pagamento) errors.push("condizioni_pagamento");
  if (!compensi_outsourcing) errors.push("compensi_outsourcing");

  if (modalità_compenso === "Forfait") {
    if (!compenso_complessivo) errors.push("compenso_complessivo");
    if (!dettagli_fatturazione_compenso)
      errors.push("dettagli_fatturazione_compenso");
    if (!percentuale_spese) errors.push("percentuale_spese");
    if (compenso_condiviso === "Sì" && !dettagli_divisione)
      errors.push("dettagli_divisione");
    if (compenso_condiviso === "Sì" && !team_compenso_condiviso)
      errors.push("team_compenso_condiviso");
    if (!condizioni_pagamento) errors.push("condizioni_pagamento");
    if (compensi_outsourcing === "Sì" && !dettagli_compensi_outsourcing)
      errors.push("dettagli_compensi_outsourcing");
    if (!periodo_competenza_inizio) errors.push("periodo_competenza_inizio");
    if (!periodo_competenza_fine) errors.push("periodo_competenza_fine");
  }

  if (modalità_compenso === "Listino/Tariffa oraria") {
    if (!riferimento_calcolo) errors.push("riferimento_calcolo");
    if (!percentuale_spese) errors.push("percentuale_spese");
    if (compenso_condiviso === "Sì" && !dettagli_divisione)
      errors.push("dettagli_divisione");
    if (compenso_condiviso === "Sì" && !team_compenso_condiviso)
      errors.push("team_compenso_condiviso");
    if (!condizioni_pagamento) errors.push("condizioni_pagamento");
    if (compensi_outsourcing === "Sì" && !dettagli_compensi_outsourcing)
      errors.push("dettagli_compensi_outsourcing");

    if (riferimento_calcolo === "Listino personalizzato") {
      if (!tariffa_specifica) errors.push("tariffa_specifica");
    }
  }

  if (modalità_compenso === "Mista") {
    if (!tariffa_oraria) errors.push("tariffa_oraria");
    if (!compenso_combinazione_forfait_listino)
      errors.push("compenso_combinazione_forfait_listino");
    if (!percentuale_spese) errors.push("percentuale_spese");
    if (compenso_condiviso === "Sì" && !dettagli_divisione)
      errors.push("dettagli_divisione");
    if (compenso_condiviso === "Sì" && !team_compenso_condiviso)
      errors.push("team_compenso_condiviso");
    if (!condizioni_pagamento) errors.push("condizioni_pagamento");
    if (compensi_outsourcing === "Sì" && !dettagli_compensi_outsourcing)
      errors.push("dettagli_compensi_outsourcing");

    if (tariffa_oraria === "Listino personalizzato") {
      if (!tariffa_specifica) errors.push("tariffa_specifica");
    }
  }

  if (percentuale_spese === "Altra percentuale") {
    if (!percentuale_spese_specifica)
      errors.push("percentuale_spese_specifica");
  }
  return errors;
};

export const validationPracticeStepFour = (practice) => {
  const {
    tipologia_verifica,
    livello_rischio,
    controlli_AML,
    controlli_AML_Sì,
  } = practice?.AML || {};

  const errors = [];

  if (!controlli_AML) errors.push("controlli_AML");

  if (controlli_AML === "Sì") {
    if (!controlli_AML) errors.push("controlli_AML");
    if (!tipologia_verifica) errors.push("tipologia_verifica");
    if (!livello_rischio) errors.push("livello_rischio");
  }

  if (controlli_AML_Sì === "No") {
    if (!tipologia_verifica) errors.push("tipologia_verifica");
    if (!livello_rischio) errors.push("livello_rischio");
  }
  return errors;
};

export const validationPracticeStepSubmission = (practice) => {
  const errors = [];

  // L'utente deve scegliere esplicitamente Sì o No
  if (!practice?.submission?.richiesta_submission)
    errors.push("richiesta_submission");

  return errors;
};
